import React from 'react';
import queryString from 'querystring';
import PropTypes from 'prop-types';
import {Button, InlineNotification, InputField} from '@elixir/components';

import './resetPassword.scss';
import FormTitle from '../common/formTitle/formTitle';
import LoginContainer from '../loginContainer';
import crypto from '../common/crypto';
import {PostRequest} from '../../common/service/PostRequest';
import ReactDOM from 'react-dom';

export default class ResetPassword extends React.Component {

    constructor (props) {
        super(props);

        this.state = {
            username: '',
            oldPassword: '',
            newPassword: '',
            verifyNewPassword: '',
            showFormValidation: false,
            errorMessage: ''
        };
    }

    static contextTypes = {
        translator: PropTypes.func.isRequired
    };

    onInputChange (stateKey, newValue) {
        let newState = {
            errorMessage: null,
            showFormValidation: false
        };
        newState[ stateKey ] = newValue;
        this.setState(newState);
    }

    onChangePassword (isSubmitDisabled) {
        const {
            username,
            newPassword,
            verifyNewPassword
        } = this.state;
        const passwordsMatch = newPassword === verifyNewPassword;

        if (!isSubmitDisabled) {
            if (!passwordsMatch) {
                const verifyPasswordErrorMessage = this.context.translator('resetPassword.verifyPasswordErrorMessage');
                this.setState({
                    showFormValidation: true,
                    errorMessage: verifyPasswordErrorMessage
                });
            }
            else {
                const search = this.props.location.search;
                const searchParams = queryString.parse(search.substring(1));
                const data = {
                    userName: username,
                    oldPassword: searchParams.token,
                    password: crypto.encryptWithServerPublicKey(newPassword)
                };
                const tokenTimeoutLength = 86400 * 365; //one year
                const loginUrl = new URL('rest/v2/Session', window.location.origin);
                const params = {
                    applicationId: 'OPERATOR',
                    timeoutSeconds: tokenTimeoutLength,
                    passwordIsToken: true
                };
                loginUrl.search = new URLSearchParams(params);

                const request = new PostRequest();
                request.post(loginUrl, data).then(
                    (result) => {
                        if (result.errorMessage) {
                            const node = ReactDOM.findDOMNode(this);
                            const usernameInput = node.querySelector('#usernameInput');
                            usernameInput.focus();

                            this.setState({
                                username: '',
                                oldPassword: '',
                                newPassword: '',
                                verifyNewPassword: '',
                                errorMessage: result.errorMessage
                            });
                        }
                        else {

                            this.setState({errorMessage: null});

                            window.localStorage.setItem('loginToken::operator', result);
                            this.props.history.push('/app/user');
                        }
                    },
                    (error) => {}
                );
            }
        }


    }

    render () {
        const {
            username,
            oldPassword,
            newPassword,
            verifyNewPassword,
            showFormValidation,
            errorMessage
        } = this.state;

        const hasUsernameFilled = username.length > 0;
        const hasOldPasswordFilled = oldPassword.length > 0;
        const hasNewPasswordFilled = newPassword.length > 0;
        const hasVerifyNewPasswordFilled = verifyNewPassword.length > 0;
        const isChangePasswordButtonDisabled = !(hasOldPasswordFilled && hasUsernameFilled && hasNewPasswordFilled && hasVerifyNewPasswordFilled);


        const changePasswordButtonLabel = this.context.translator('resetPassword.changePasswordButtonLabel');


        let error = '';

        if (showFormValidation && errorMessage) {

            error = (<InlineNotification className="loginError"
                                         type="error"
                                         isDismissable={false}
                                         message={errorMessage}/>);
        }


        return (
            <LoginContainer
                className="resetPasswordComponent"
                onEnterKeydown={this.onChangePassword.bind(this, isChangePasswordButtonDisabled)}>

                <div className="errorContainer">
                    {error}
                </div>

                <FormTitle titleKey="resetPassword.resetPasswordTitle"/>

                <div className="resetPasswordComponent">

                    <InputField
                        className="username"
                        id="usernameInput"
                        controlClassName="usernameInput"
                        onValueChange={this.onInputChange.bind(this, 'username')}
                        value={username}
                        label="resetPassword.usernameInputLabel"/>

                    <InputField
                        className="oldPassword"
                        id="oldPasswordInput"
                        inputType="password"
                        onValueChange={this.onInputChange.bind(this, 'oldPassword')}
                        value={oldPassword}
                        label="resetPassword.oldPasswordInputLabel"/>

                    <InputField
                        className="newPassword"
                        id="newPasswordInput"
                        inputType="password"
                        onValueChange={this.onInputChange.bind(this, 'newPassword')}
                        value={newPassword}
                        label="resetPassword.newPasswordInputLabel"/>

                    <InputField
                        className="verifyNewPassword"
                        id="verifyNewPasswordInput"
                        inputType="password"
                        onValueChange={this.onInputChange.bind(this, 'verifyNewPassword')}
                        value={verifyNewPassword}
                        label="resetPassword.verifyNewPasswordInputLabel"/>

                    <Button className="changePasswordButton"
                            name="changePasswordButton"
                            type="primary"
                            disabled={isChangePasswordButtonDisabled}
                            onClick={this.onChangePassword.bind(this)}>
                        <span>{changePasswordButtonLabel}</span>
                    </Button>

                </div>
            </LoginContainer>
        );
    }
}

